<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-07-01 11:39:50 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-27 17:57:57 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/exhibitor-card/src/izt-exhibitor-card.vue
 * @Description  : 展商卡片
-->
<style lang="scss" scoped>
.izt-exhibitor-card-container {
  background: #FFFFFF;
  box-shadow: 0px 5px 6px 0px rgba(0,0,0,0.1);
  border-radius: 24px;
  min-height: 0;
  overflow: hidden;
  color: rgba($color: #000000, $alpha: .65);
  .head-area-container {
    min-height: 0;
    background-color: var(--izt-theme-color);
    color: var(--izt-theme-text-color-65);
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    .exhibitor-name {
      display: flex;
      align-items: center;
      gap: 16px;
      .name {
        width: fit-content;
        font-weight: bold;
        font-size: 28px;
        min-width: 0;
        span {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .hollow-label {
        flex-shrink: 0;
        border-color: var(--izt-theme-text-color-100);
        color: var(--izt-theme-text-color-100);
        opacity: 0.45;
        background: color-mix(in srgba, var(--izt-theme-color) 10%, transparent);
      }
    }
  }
  .main-container {
    padding: 24px;
    .exhibitor-label {
      margin-top: 16px;
      display: flex;
      flex-wrap: wrap;
      gap: 16px 8px;
      // 最多显示3行：30px(标签高度) × 3行 + 16px(行间距) × 2
      max-height: calc(30px * 3 + 16px * 2);
      overflow: hidden;
    }
    .exhibitor-album {
      margin-top: 16px;
    }
    .booth-number {
      display: flex;
      align-items: center;
      margin-top: 16px;
      .label {
        font-weight: 400;
        font-size: 22px;
        color: rgba(0,0,0,0.45);
      }
      .value {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 500;
        font-size: 22px;
        color: rgba(0,0,0,0.65);
        .label_text {
          text-decoration: underline;
        }
        .map-icon {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="izt-exhibitor-card-container" @click.stop="emit('click', {data, type: 'exhibitor'})">
    <div class="head-area-container">
      <div class="exhibitor-name">
        <div class="name">
          <span>{{ data.name }}</span>
        </div>
        <div class="hollow-label" v-if="data.provincename">{{ data.provincename }}</div>
      </div>
      <izt-preferred-tag :text="selection_reason" v-if="!!selection_reason"/>
    </div>
    <div class="main-container">
      <izt-ai-rec-short :text="data.recommend_reason"/>
      <div class="exhibitor-label" v-if="data?.qcc_tags?.length">
        <div class="real-label" v-for="item in data.qcc_tags">
          <span>{{ item }}</span>
        </div>
      </div>
      <div class="exhibitor-album" v-if="product_icons.length">
        <izt-album :list="product_icons" preview></izt-album>
      </div>

      <div class="booth-number" v-if="data.booth_no">
        <div class="label">{{ $t('card.展位号') }}</div>
        <div class="value" v-if="!configStore.otherConfig?.mapConfig?.visible">{{ data.booth_no }}</div>
        <div class="value" v-else @click.stop="emit('on-map', {data, type: 'exhibitor'})">
          <div class="label_text">{{ data.booth_no }}</div>
          <img class="map-icon" src="@/assets/map-icon.png" mode="aspectFill">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="izt-exhibitor-card">
  import { useConfigStore } from '@/stores/modules/config.js'
  import { computed } from 'vue';

  defineOptions({ name: 'izt-exhibitor-card' })

  const props = defineProps({
    data: { type: Object, default: () => ({}) }
  })

  const emit = defineEmits(['click', 'on-map'])
  const configStore = useConfigStore()

  const selection_reason = computed(() => {
    try {
      const data = JSON.parse(props.data.selection_reason)
      if (data.length === 0) return null
      return data[0]
    } catch  {
      if(!props.data.selection_reason) return null
      return props.data.selection_reason
    }
  })

  const product_icons = computed(() => {
    if (!props.data.product_icons) return []
    return props.data.product_icons.split(',').map(s => s.trim())
  });
</script>